<template>
  <vx-tooltip :text="$t('whisper')" position="bottom">
    <vs-button
      class="includeIcon includeIconOnly"
      color="success"
      type="border"
      @click="process">
      <i class="c-icon-whisper"></i>
    </vs-button>
  </vx-tooltip>
</template>

<script>
import Cti from '@/models/Cti'

export default {
  name: 'CtiWhisper',
  props: {
    server: {
      required: true
    },
    isDisplay: {
      default: false
    }
  },
  computed: {
    phoneNumber () {
      return this.$store.getters.phoneNumber
    },
    extension () {
      return this.$store.getters.extension
    }
  },
  methods: {
    process () {
      if (this.isDisplay) {
        return
      }

      if (this.phoneNumber === null || this.phoneNumber.toString().length <= 0) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Phone Number is Required.',
          color:'danger',
          position:'top-right'
        })
        return
      }

      const data = {
        extension: this.extension,
        channel: this.phoneNumber
      }

      try {
        Cti.whisper(this.server.domain, data)
        this.$vs.notify({
          title:'CTI Notice',
          text:`${this.phoneNumber} 속삭임 시작`,
          color:'danger',
          position:'top-right'
        })
      } catch (e) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Whisper Error',
          color:'danger',
          position:'top-right'
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
